@if (formSpec) {
  <lm-form-content-form
    #LMFormContentForm
    [formSpec]="formSpec"
    [formOptions]="formOptions"
    [specFields]="specFields"
    [placeHolder]="placeHolder"
    [layout]="layout"
    [model]="model"
    (keyup.enter)="onSearchClicked($event)"
    (fieldEvent)="onFieldEvent($event)"
  ></lm-form-content-form>
}
<!--(focusout)="onSearchClicked($event)"-->
@if (!isCodeBlockFilter && !suppressSearchButtons) {
  <div class="lm-search-button-container">
    <!--
    Annoying but we need 'btn-tertiary' to appear first
    in the class list so that some sohoxi css rules will work
    -->
    <button id="{{searchButtonId}}" soho-button="tertiary" class="btn-tertiary lm-run-search-button" (click)="onSearchClicked($event)">{{searchTitle}}</button>
    <button id="{{clearButtonId}}" soho-button="tertiary" class="btn-tertiary lm-clear-search-button" (click)="onClearSearchClicked($event)">{{clearTitle}}</button>
  @if (displayAdHocSearchButton) {
    <button id="{{searchButtonId}}" soho-button="tertiary" class="btn-tertiary lm-run-search-button" (click)="onAdHocClicked($event)">{{customizeTitle}}<span class="lm-adhoc-filter-count" id="{{customizeButtonId}}_count"></span></button>
  }
  </div>
}
